import classNames from 'clsx';
import { ReactComponent as ArrowIcon } from 'img/icons/arrowBack.svg';
import { ReactComponent as CoEditIcon } from 'img/icons/coedit.svg';
import { ReactComponent as CloudIcon } from 'mrg-icons/src/mailru/logotypes/cloud.svg';
import React, { createRef, PureComponent, ReactElement } from 'react';
import { connect } from 'react-redux';
import { downloadItem, getCurrentState, getIsCloudAvailabe, goTo, updateItemFavoriteFlag } from 'reactApp/appHelpers/appHelpers';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { publishHelper } from 'reactApp/appHelpers/publishHelper';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { RenamedFileMeta, setRenamedFileIdInsideViewer } from 'reactApp/appHelpers/updateRenamedFileInsideViewer';
import { EFrom } from 'reactApp/components/SharingNew/SharingNew.types';
import { renderSharingNew } from 'reactApp/components/SharingNewBiz/SharingNew.helpers';
import { getEditorItem, isEnableRenamingInsideEditor } from 'reactApp/modules/editor/editor.selectors';
import { EditorItem } from 'reactApp/modules/editor/editor.types';
import { getFeatureMyOfficeEditorPromo, getFeatureWopi } from 'reactApp/modules/features/features.selectors';
import { addToFavorites, removeFromFavorites } from 'reactApp/modules/modifying/modifying.actions';
import { renameRequest } from 'reactApp/modules/modifying/sagas/rename.saga';
import { goToRegisterPage } from 'reactApp/modules/ph/ph.helpers';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { loadUser } from 'reactApp/modules/user/user.thunkActions';
import styles from 'reactApp/ui/EditorHeader/EditorHeader.css';
import { HeaderButton } from 'reactApp/ui/EditorHeader/HeaderButton';
import { HeaderFileName } from 'reactApp/ui/EditorHeader/HeaderFileName';
import { ShareButtonCoEditPopup } from 'reactApp/ui/EditorHeader/ShareButtonCoEditPopup';
import { EColor, FavoriteIcon } from 'reactApp/ui/FavoriteIcon/FavoriteIcon';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { EditorHeaderButtonPromoContainer as MyOfficePromoHeaderButton } from 'reactApp/ui/MyOfficePromo/EditorHeaderButton/EditorHeaderButtonPromoContainer';
import { DownloadIcon, LinkIcon, ShareIcon, UploadIcon } from 'reactApp/ui/VKUIIcons';
import { createGaSender, sendGa } from 'reactApp/utils/ga';
import { noop } from 'reactApp/utils/helpers';

const updateWeblinkInUrlAction = (id, weblink): void => {
    const state = getCurrentState();

    if (!state) {
        return;
    }

    const { ...params } = state.params;

    if (weblink) {
        params.weblink = weblink;
    } else {
        delete params.weblink;
    }

    goTo({ id, params });
};

interface MapState {
    backLink: string;
    updateWeblinkInUrl(id: EditorItem['id'] | undefined, weblink: EditorItem['weblink']);
    renameItem(file: EditorItem | null, newName: string);
    isAnonymous: boolean;
    enableRenaming: boolean;
    file: EditorItem | null;
    id?: string;
    isWopiFeatureEnabled?: boolean;
    myOfficePromoEditorEnabled?: boolean;
}

interface Props extends MapState {
    showBubble: boolean;
    onBubbleShow();
    toggleFavorite(file: EditorItem);
    loadUser();
    showNotify(options);
    onBackToCloud: (() => void) | null;
    isPublic: boolean;
    isStock: boolean;
    enableFavorites: boolean;
    gaCategory?: string;
    itemSelector(state);
    returnButtonTitle?: string;
    isViewer?: boolean;
    itemStorage?: EStorageType | null;
    licenseExpired?: boolean;
    downloadDropdownList?: any[];
    getRenamedFileIdInsideViewer: () => RenamedFileMeta;
    setRenamedFileIdInsideViewer: (init: RenamedFileMeta) => void;
}

interface State {
    showBubble: boolean;
    isDownloadOpen: boolean;
}

const mapStateToProps = (state, props): MapState => {
    const { isPublic, itemSelector = getEditorItem } = props;

    const isAnonymous = UserSelectors.isAnonymous(state);
    const myOfficePromoEditorEnabled = !!getFeatureMyOfficeEditorPromo(state);
    const file = itemSelector(state);

    const isWopiFeatureEnabled = getFeatureWopi(state);

    return {
        backLink: isPublic ? '/home' : `/home${file?.parent}`,
        updateWeblinkInUrl: updateWeblinkInUrlAction,
        renameItem: renameRequest,
        isAnonymous,
        enableRenaming: isEnableRenamingInsideEditor(state),
        file,
        id: file?.id,
        isWopiFeatureEnabled,
        myOfficePromoEditorEnabled,
    };
};

const mapDispatchToProps = (dispatch) => ({
    loadUser: (): void => dispatch(loadUser()),
    showNotify: (options): void => dispatch(showSnackbarAction(options)),
    toggleFavorite: (item: EditorItem): void =>
        dispatch(item.isInFavorites ? removeFromFavorites({ items: [item] }) : addToFavorites({ items: [item], from: 'editor' })),
    setRenamedFileIdInsideViewer: (init: RenamedFileMeta) => dispatch(setRenamedFileIdInsideViewer(init)),
});

export class EditorHeaderComponent extends PureComponent<Props, State> {
    static defaultProps = {
        showBubble: false,
        onBubbleShow: noop,
        toggleFavorite: noop,
        updateWeblinkInUrl: noop,
        renameItem: noop,
        loadUser: noop,
        showNotify: noop,
        isPublic: false,
        isStock: false,
        enableFavorites: false,
        isAnonymous: false,
        backLink: '',
        file: null,
        id: '',
        onBackToCloud: null,
        gaCategory: '',
        returnButtonTitle: 'Вернуться в Облако',
    };

    public readonly state: State = {
        showBubble: false,
        isDownloadOpen: false,
    };

    buttonTextRef = createRef<HTMLDivElement>();

    gaSender = createGaSender(`${this.props.gaCategory}-${this.props.isPublic ? 'public' : 'home'}`);

    componentDidMount(): void {
        const { file, onBubbleShow, showBubble, loadUser, isPublic, updateWeblinkInUrl } = this.props;
        this.gaSender('show');

        if (isPublic) {
            sendGa('public-edit', 'file-type', 'document');
            const ext = file?.ext;
            if (ext) {
                sendGa('public-edit', 'file-extention', ext);
            }
        } else {
            updateWeblinkInUrl(file?.id, file?.weblink);
        }

        if (this.buttonTextRef.current && showBubble) {
            onBubbleShow();
            this.setState({
                showBubble: true,
            });
        }

        loadUser();
    }

    componentDidUpdate(prevProps: Props): void {
        if (prevProps.file?.id !== this.props.file?.id || prevProps.file?.weblink !== this.props.file?.weblink) {
            this.props.updateWeblinkInUrl(this.props.file?.id, this.props.file?.weblink);
        }
    }

    handlePublish = (e?: React.MouseEvent<HTMLDivElement>): void => {
        const { file } = this.props;

        e?.stopPropagation();

        this.gaSender('publish', 'click');

        this.setState({
            showBubble: false,
        });

        publishHelper({ item: file, gaSuffix: '_header' });
    };

    handleShareDocument = () => {
        const { id = '' } = this.props;

        this.gaSender('share', 'click');

        renderSharingNew({ id, from: EFrom.SHARING });
    };

    handleToggleFavorite = (): void => {
        const { toggleFavorite, file } = this.props;
        this.gaSender('favorite', 'click');
        const isInFavoritesPrev = !!file?.isInFavorites;

        if (!file) {
            return;
        }

        toggleFavorite(file);
        this.gaSender('favorite', 'success');
        updateItemFavoriteFlag(file?.id, !isInFavoritesPrev);
    };

    handleFileNameClick = (): void => this.gaSender('rename', 'click');

    handleFileNameEdit = ({ value }): Promise<any> => {
        const { showNotify, file, renameItem, setRenamedFileIdInsideViewer } = this.props;

        const trimedValue = value.trim();

        if (trimedValue === file?.nameWithoutExt) {
            return Promise.resolve();
        }

        if (!trimedValue) {
            showNotify({
                type: SnackbarTypes.failure,
                text: 'Название не может быть пустым',
                id: 'rename',
                closable: true,
            });
            return Promise.reject();
        }

        const newName = `${trimedValue}.${file?.ext}`;

        return renameItem(file, newName)
            .then(() => {
                this.gaSender('rename', 'success');

                /**
                 * При переименовании файла из редактора МойОфис необходимо обновить вкладку просмотрщика.
                 * Отслеживание изменений происходит в localstorage.
                 */
                if (file?.home && file?.name) {
                    setRenamedFileIdInsideViewer({ newId: file.home.split(file.name).join(newName), outdateId: file.home });
                }

                goTo({ id: this.props.file?.id });
                showNotify({
                    id: 'document-rename-success',
                    type: SnackbarTypes.success,
                    text: 'Файл успешно переименован',
                    closable: true,
                });
            })
            .catch((error) => {
                this.gaSender('rename', 'error');
                showNotify({
                    type: SnackbarTypes.failure,
                    text: `Не удалось переименовать файл: ${error}`,
                    id: 'document-rename-error',
                    closable: true,
                });
                return Promise.reject();
            });
    };

    handleDownload = (): void => {
        const { file } = this.props;

        this.gaSender('download', 'click');

        downloadItem({ itemOrId: file });
    };

    handleDownloadDropdown = () => {
        this.setState(({ isDownloadOpen }) => ({
            isDownloadOpen: !isDownloadOpen,
        }));
    };

    handleSaveToCloud = (): void => {
        const fileId = this.props.file?.id;

        this.gaSender('savetocloud', 'click');

        if (!fileId) {
            return;
        }

        toolbarActions.clone({ id: fileId, source: 'editor' });
    };

    closeBubble = (): void => {
        this.setState({
            showBubble: false,
        });
    };

    private renderRightGroup = (): ReactElement | null => {
        const { file, isPublic, isStock, downloadDropdownList, isWopiFeatureEnabled, isViewer } = this.props;
        const { showBubble, isDownloadOpen } = this.state;

        if (isStock) {
            return null;
        }

        const accessTitle = file?.weblink ? 'Настройки доступа' : 'Открыть доступ';
        const shareButton = (
            <div>
                <HeaderButton
                    title={accessTitle}
                    icon={<ShareIcon />}
                    onClick={this.handlePublish}
                    size={181}
                    textRef={this.buttonTextRef}
                />
            </div>
        );

        return (
            <>
                <HeaderButton
                    title="Скачать"
                    icon={<DownloadIcon />}
                    onClick={this.handleDownload}
                    dropdownList={downloadDropdownList}
                    onDropdownClick={this.handleDownloadDropdown}
                    isDropdownOpen={isDownloadOpen}
                    isWopiFeatureEnabled={isWopiFeatureEnabled}
                />
                {isPublic ? (
                    <HeaderButton
                        title="Поделиться ссылкой"
                        icon={<LinkIcon />}
                        onClick={this.handleShareDocument}
                        textRef={this.buttonTextRef}
                    />
                ) : (
                    <>
                        {showBubble && (
                            <FloatingTooltip
                                target={this.buttonTextRef}
                                placement={ETooltipPlacement.bottomEnd}
                                onClose={this.closeBubble}
                                hideArrow
                                qaId="tooltip-co-edit"
                            >
                                <div className={styles.bubble}>
                                    <div className={styles.bubbleIcon}>
                                        <CoEditIcon width={145} height={100} />
                                    </div>
                                    <div>
                                        <div className={styles.bubbleTitle}>Совместное редактирование документов</div>
                                        <div className={styles.bubbleText}>
                                            Работайте совместно. Вы можете открывать доступ к вашим документам по секретной ссылке.
                                        </div>
                                    </div>
                                </div>
                            </FloatingTooltip>
                        )}
                        {!isPublic && !isViewer && !isStock ? <ShareButtonCoEditPopup>{shareButton}</ShareButtonCoEditPopup> : shareButton}
                    </>
                )}
                <MyOfficePromoHeaderButton />
            </>
        );
    };

    render(): ReactElement {
        const {
            enableFavorites,
            backLink,
            file,
            isAnonymous,
            isPublic,
            onBackToCloud,
            returnButtonTitle = 'Вернуться в Облако',
            isViewer,
            licenseExpired = false,
            enableRenaming,
            myOfficePromoEditorEnabled = false,
        } = this.props;

        // Скрываем кнопку, т.к. у анонминого пользователя нет возможности завести облако в on-premise
        const isCloudAvailabe = IS_ONPREMISE ? !isAnonymous && getIsCloudAvailabe() : getIsCloudAvailabe();
        const showCloneToCloud = !isViewer && !isAnonymous && isPublic && !file?.home && isCloudAvailabe;
        // Скрываем кнопку в on-premise, т.к. пользователь не может сам завести себе облако
        const showCreateCloudButton = isAnonymous && !IS_ONPREMISE;

        return (
            <>
                <div className={styles.root}>
                    <div className={styles.leftGroup}>
                        {showCreateCloudButton ? (
                            <HeaderButton title="Завести Облако" onClick={goToRegisterPage} icon={<CloudIcon width={20} height={20} />} />
                        ) : (
                            isCloudAvailabe && (
                                <HeaderButton
                                    title={returnButtonTitle}
                                    link={onBackToCloud ? null : backLink}
                                    onClick={onBackToCloud || noop}
                                    icon={<ArrowIcon width={9} height={14} viewBox="0 0 5 8" />}
                                />
                            )
                        )}
                        {showCloneToCloud && (
                            <HeaderButton title="Сохранить в Облако" icon={<UploadIcon />} onClick={this.handleSaveToCloud} />
                        )}
                    </div>
                    <div className={styles.middleGroup}>
                        <HeaderFileName
                            fileName={file?.nameWithoutExt || ''}
                            readOnly={!enableRenaming || isPublic || !!file?.readOnly}
                            onEdit={enableRenaming ? this.handleFileNameEdit : noop}
                            onClick={enableRenaming ? this.handleFileNameClick : noop}
                            title={file?.isInFavorites ? 'Убрать из избранных' : 'Добавить в избранные'}
                            icon={
                                enableFavorites ? (
                                    <FavoriteIcon
                                        onClick={this.handleToggleFavorite}
                                        className={styles.favoritesIcon}
                                        active={file?.isInFavorites}
                                        color={EColor.WHITE}
                                    />
                                ) : null
                            }
                        />
                    </div>
                    <div
                        className={classNames(styles.rightGroup, {
                            [styles.myOfficePromoEditorEnabled]: myOfficePromoEditorEnabled,
                        })}
                    >
                        {this.renderRightGroup()}
                    </div>
                </div>
                {licenseExpired && (
                    <div className={styles.license}>
                        <div>Количество лицензий закончилось</div>
                    </div>
                )}
            </>
        );
    }
}

export const EditorHeader = connect(mapStateToProps, mapDispatchToProps)(EditorHeaderComponent);
